import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";
import { Product } from "@/lib/products";

interface StickyCTAProps {
  product: Product;
  onBuyNow: () => void;
  formatPrice: (n: number) => string;
}

export const StickyCTA = ({ product, onBuyNow, formatPrice }: StickyCTAProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible || !product.available) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-card/95 backdrop-blur-md border-t border-border/50 px-4 py-3 safe-area-bottom shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <div className="flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <p className="font-bold text-foreground text-sm truncate">{product.title}</p>
          <p className="text-primary font-extrabold text-lg">{formatPrice(product.price)}</p>
        </div>
        <Button
          onClick={onBuyNow}
          className="flex-shrink-0 font-bold px-5 py-5 rounded-xl bg-accent hover:bg-accent/90 text-accent-foreground"
        >
          <ShoppingCart className="w-4 h-4 mr-2" />
          Commander
        </Button>
      </div>
    </div>
  );
};
